import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["aria-label", "onClick"]
const _hoisted_2 = ["placeholder", "onKeydown"]
const _hoisted_3 = {
  key: 0,
  class: "text-xs text-red-500 mt-1"
}

import { ref } from 'vue'
import { X } from 'lucide-vue-next'


export default /*@__PURE__*/_defineComponent({
  __name: 'ChipsInput',
  props: {
    modelValue: {},
    placeholder: {},
    disabled: { type: Boolean },
    validate: { type: Function }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const saisie = ref('')
const erreur = ref<string | null>(null)

const comparable = (v: string) => v.trim().toLowerCase()

function ajouterValeurs(brutes: string[]) {
  const valeurs = [...props.modelValue]
  erreur.value = null
  for (const brute of brutes) {
    const valeur = brute.replace(/\s+/g, ' ').trim()
    if (!valeur) continue
    const refus = props.validate?.(valeur)
    if (refus) {
      erreur.value = refus
      continue
    }
    if (!valeurs.some((v) => comparable(v) === comparable(valeur))) valeurs.push(valeur)
  }
  emit('update:modelValue', valeurs)
}

function ajouter() {
  if (!saisie.value.trim()) return
  const refuses = saisie.value
  ajouterValeurs([saisie.value])
  // Une valeur refusée reste dans le champ pour être corrigée.
  saisie.value = erreur.value ? refuses : ''
}

// « , » et « ; » valident la saisie comme Entrée.
function onKey(e: KeyboardEvent) {
  if (e.key === ',' || e.key === ';') {
    e.preventDefault()
    ajouter()
  } else if (e.key === 'Backspace' && !saisie.value && props.modelValue.length) {
    retirer(props.modelValue.length - 1)
  }
}

// Un collage de plusieurs valeurs (séparées par virgule, point-virgule ou retour) les ajoute toutes.
function onPaste(e: ClipboardEvent) {
  const texte = e.clipboardData?.getData('text') || ''
  if (!/[,;\n]/.test(texte)) return
  e.preventDefault()
  ajouterValeurs(texte.split(/[,;\n]+/))
  saisie.value = ''
}

function retirer(idx: number) {
  erreur.value = null
  emit('update:modelValue', props.modelValue.filter((_, i) => i !== idx))
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex flex-wrap items-center gap-1.5 border rounded-lg px-2 py-1.5 min-h-[42px] bg-white", [_ctx.disabled ? 'bg-gray-50' : 'focus-within:ring-2 focus-within:ring-[#22282F]/20', erreur.value ? 'border-red-300' : 'border-gray-300']])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.modelValue, (valeur, idx) => {
        return (_openBlock(), _createElementBlock("span", {
          key: valeur,
          class: "inline-flex items-center gap-1 bg-gray-100 text-gray-700 text-sm rounded-md pl-2.5 pr-1 py-0.5",
          "data-test": "chip"
        }, [
          _createTextVNode(_toDisplayString(valeur) + " ", 1),
          (!_ctx.disabled)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                type: "button",
                class: "p-0.5 rounded hover:bg-gray-200 text-gray-400 hover:text-gray-700",
                "aria-label": `Retirer ${valeur}`,
                onClick: ($event: any) => (retirer(idx))
              }, [
                _createVNode(_unref(X), { class: "w-3 h-3" })
              ], 8, _hoisted_1))
            : _createCommentVNode("", true)
        ]))
      }), 128)),
      (!_ctx.disabled)
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((saisie).value = $event)),
            type: "text",
            placeholder: _ctx.modelValue.length ? '' : _ctx.placeholder,
            class: "flex-1 min-w-[10rem] bg-transparent outline-none text-sm py-1 px-1",
            "data-test": "chip-input",
            onKeydown: [
              _withKeys(_withModifiers(ajouter, ["prevent"]), ["enter"]),
              onKey
            ],
            onBlur: ajouter,
            onPaste: onPaste
          }, null, 40, _hoisted_2)), [
            [_vModelText, saisie.value]
          ])
        : _createCommentVNode("", true)
    ], 2),
    (erreur.value)
      ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(erreur.value), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})